var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRankUpMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7668_2278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 16C4.448 16 4 16.448 4 17C4 17.552 4.448 18 5 18H13C13.552 18 14 17.552 14 17C14 16.448 13.552 16 13 16H5Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98725 0C8.73125 0 8.49527 0.0860062 8.29926 0.281007C7.29926 1.28101 1.30026 7.28103 0.299256 8.28103C-0.329745 8.91104 0.0962438 10 0.987245 10H3.98725V13C3.98725 13.552 4.43525 14 4.98725 14H12.9873C13.5393 14 13.9873 13.552 13.9873 13V10H16.9873C17.8783 10 18.3363 8.91104 17.7063 8.28103L9.70625 0.281007C9.51025 0.0860062 9.24325 0 8.98725 0Z",
    fill: "#969696"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7668_2278"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankUpMenu);
export default __webpack_public_path__ + "static/media/Rank-up-menu.6c623ba424236a7873339cf4aded39f3.svg";
export { ForwardRef as ReactComponent };